// extracted by mini-css-extract-plugin
export default {"wrap":"wrap-Wxc_","cover":"cover-ZRGr","more":"more-yaFv"};